import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "@/App.css";
import { Phone, Calendar, User, Mail, MessageSquare, ChevronDown, Check, Clock, Heart, Shield, Users, Brain, Sparkles, Star, ArrowRight, MapPin, ChevronRight, Facebook, Instagram, Linkedin, Dumbbell, Palette, Users2, Building2, Plus, Minus, X } from "lucide-react";
import TMSPage from "@/pages/TMSPage";
import EsketaminePage from "@/pages/EsketaminePage";
import AcceleratedTMSPage from "@/pages/AcceleratedTMSPage";
import CareersPage from "@/pages/CareersPage";

// ============ IMAGES FROM AWAREHUB WEBSITE ============
const IMAGES = {
  logo: "https://awarehub.com.au/wp-content/uploads/awarehub-logo-transparent-003.png",
  logoWhite: "https://awarehub.com.au/wp-content/uploads/awarehub-logo-transparent-for-use-on-dark-background-002.png",
  drLisa: "https://awarehub.com.au/wp-content/uploads/lisa.jpg",
  drLisaDirector: "https://awarehub.com.au/wp-content/uploads/Dr-Lisa-Myers-AwareHub-Director-and-Psychiatrist--e1732146069656.jpg",
  tmsNurse: "https://awarehub.com.au/wp-content/uploads/Senior-TMS-Nurse-Aashna-Lal-performing-TMS-Service_web.jpg",
  reception: "https://awarehub.com.au/wp-content/uploads/reception-area-2-2-1024x683.jpg",
  danielleFranco: "https://awarehub.com.au/wp-content/uploads/Danielle-Franco.webp",
  dva: "https://awarehub.com.au/wp-content/uploads/DVA-Logo.png",
  medicare: "https://awarehub.com.au/wp-content/uploads/Logo-Medicare-transparent.png",
  ndis: "https://awarehub.com.au/wp-content/uploads/NDIS-logo.png",
  logoSvg: "https://awarehub.com.au/wp-content/uploads/2awarelogo2.svg",
};

// Background image for hero
const BACKGROUND_IMAGE = "https://images.unsplash.com/photo-1758273240403-052b3c99f636?auto=format&fit=crop&w=1920&q=80";

// ============ POPUP FORM MODAL ============
const AppointmentModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", location: "Sydney", service: "TMS/Esketamine", message: "" });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-end p-4 md:p-8" data-testid="appointment-modal">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose} />
      
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-modal-in mr-0 md:mr-8">
        <div className="bg-[#6BACA9] p-6 text-center relative">
          <button 
            onClick={onClose} 
            data-testid="modal-close-btn"
            className="absolute top-4 right-4 w-8 h-8 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-colors"
          >
            <X className="w-4 h-4 text-white" />
          </button>
          <div className="inline-flex items-center justify-center w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl mb-3">
            <Calendar className="w-7 h-7 text-white" />
          </div>
          <h2 className="text-xl font-bold text-white">ENQUIRE NOW</h2>
          <p className="text-white/80 mt-1 text-sm">Fill in your details and we'll get back to you</p>
        </div>

        <form className="p-6 space-y-4">
          <select className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-700" value={formData.location} onChange={(e) => setFormData({...formData, location: e.target.value})}>
            <option value="Sydney">Sydney</option>
            <option value="Bundaberg">Bundaberg</option>
          </select>
          <input type="text" placeholder="Your Name *" data-testid="modal-name" className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-800 placeholder-slate-400" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} />
          <input type="email" placeholder="Your Email *" data-testid="modal-email" className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-800 placeholder-slate-400" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} />
          <input type="tel" placeholder="Your Phone *" data-testid="modal-phone" className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-800 placeholder-slate-400" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} />
          <select className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-700" value={formData.service} onChange={(e) => setFormData({...formData, service: e.target.value})}>
            <option value="TMS/Esketamine">TMS/Esketamine</option>
            <option value="ADHD">ADHD</option>
            <option value="Depression">Depression</option>
            <option value="Psychiatrist">Psychiatrist</option>
            <option value="Psychology">Psychology</option>
            <option value="Other">Other</option>
          </select>
          <textarea placeholder="Any additional information?" data-testid="modal-message" rows={3} className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-800 placeholder-slate-400 resize-none" value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} />
          <button type="submit" data-testid="modal-submit-btn" className="w-full bg-[#6BACA9] hover:bg-[#5D9E9B] text-white py-3 rounded-lg font-semibold transition-all">
            SUBMIT
          </button>
        </form>

        <div className="bg-slate-50 px-6 py-4 flex items-center justify-center gap-4 border-t border-slate-200">
          <img src={IMAGES.dva} alt="DVA" className="h-6" />
          <img src={IMAGES.medicare} alt="Medicare" className="h-6" />
          <img src={IMAGES.ndis} alt="NDIS" className="h-6" />
        </div>
      </div>
    </div>
  );
};

// ============ NAVIGATION ============
const Navigation = ({ onBookClick }) => (
  <nav className="w-full absolute top-0 left-0 right-0 z-50" data-testid="main-navigation">
    <div className="bg-[#6BACA9] py-2 px-4">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <p className="text-white text-sm font-medium tracking-wide">AWAREHUB BUNDABERG TMS NOW OPEN!</p>
        <div className="flex items-center gap-3">
          <a href="https://www.facebook.com/awarehubclinic" target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
            <Facebook className="w-4 h-4 text-white" />
          </a>
          <a href="https://www.instagram.com/awarehub_clinic/" target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
            <Instagram className="w-4 h-4 text-white" />
          </a>
          <a href="https://www.linkedin.com/in/lisa-myers-psychiatrist/" target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
            <Linkedin className="w-4 h-4 text-white" />
          </a>
        </div>
      </div>
    </div>
    <div className="bg-white/95 backdrop-blur-sm shadow-lg py-3 px-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2" data-testid="logo">
            <img src={IMAGES.logo} alt="AwareHub Logo" className="h-12" />
          </div>
          <Link to="/tms" className="text-[#6BACA9] hover:text-[#5D9E9B] font-semibold text-sm transition-colors" data-testid="nav-new-tms">New TMS</Link>
          <Link to="/accelerated-tms" className="text-[#6BACA9] hover:text-[#5D9E9B] font-semibold text-sm transition-colors" data-testid="nav-accelerated-tms">Accelerated TMS</Link>
          <Link to="/esketamine" className="text-[#6BACA9] hover:text-[#5D9E9B] font-semibold text-sm transition-colors" data-testid="nav-new-esketamine">New Esketamine</Link>
          <Link to="/careers" className="text-[#6BACA9] hover:text-[#5D9E9B] font-semibold text-sm transition-colors" data-testid="nav-careers">Careers</Link>
        </div>
        <div className="flex items-center gap-4">
          <a href="tel:1300029273" data-testid="phone-number" className="hidden md:flex items-center gap-2 text-slate-700 hover:text-[#6BACA9] transition-colors">
            <div className="w-10 h-10 rounded-full bg-[#6BACA9]/10 flex items-center justify-center">
              <Phone className="w-5 h-5 text-[#6BACA9]" />
            </div>
            <div>
              <p className="text-xs text-slate-500">Call us now</p>
              <p className="font-bold text-sm">1300 029 273</p>
            </div>
          </a>
          <button onClick={onBookClick} data-testid="nav-book-now-btn" className="bg-[#6BACA9] hover:bg-[#5D9E9B] text-white px-6 py-3 rounded-md font-semibold flex items-center gap-2 transition-all text-sm">
            ENQUIRE NOW
          </button>
        </div>
      </div>
    </div>
  </nav>
);

// ============ COVER SECTION WITH INLINE FORM ============
const CoverSection = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", location: "Sydney", service: "TMS/Esketamine", message: "" });
  
  return (
    <section className="relative min-h-screen overflow-hidden" data-testid="cover-section">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${BACKGROUND_IMAGE})` }} />
      <div className="absolute inset-0 bg-gradient-to-r from-[#5D9E9B]/95 via-[#6BACA9]/90 to-[#5D9E9B]/80" />
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`, backgroundSize: "50px 50px" }} />
      
      <div className="absolute top-40 left-10 w-20 h-20 border border-white/20 rounded-2xl rotate-12 animate-float" />
      <div className="absolute bottom-40 left-20 w-16 h-16 border border-white/30 rounded-full animate-float" style={{ animationDelay: "0.5s" }} />

      <div className="relative max-w-7xl mx-auto px-6 pt-40 pb-20 grid lg:grid-cols-2 gap-12 items-center min-h-screen">
        <div className="space-y-8">
          <h1 className="text-4xl lg:text-5xl font-bold leading-tight">
            <span className="text-white">Bespoke Mental Health</span><br />
            <span className="text-white">&</span> <span className="text-cyan-200">TMS Clinic</span><br />
            <span className="text-white">In Sydney</span>
          </h1>
          
          <p className="text-white/80 text-lg max-w-xl">A dedicated and holistic mental health practice and a space for you to slow down, be mindful and enhance your mental wellbeing.</p>
          
          <div className="space-y-3">
            {["Multi-disciplinary mental health services", "Psychiatry, psychology and allied health", "TMS & Esketamine treatment", "Evidence-based clinical care", "Individualised care"].map((item, i) => (
              <div key={i} className="flex items-center gap-3 text-white/90">
                <div className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center"><Check className="w-3 h-3 text-white" /></div>
                <span className="text-sm">{item}</span>
              </div>
            ))}
          </div>
          
          <div className="flex items-center gap-6 pt-4">
            <img src={IMAGES.dva} alt="DVA" className="h-10 brightness-0 invert opacity-80" />
            <img src={IMAGES.medicare} alt="Medicare" className="h-10 brightness-0 invert opacity-80" />
            <img src={IMAGES.ndis} alt="NDIS" className="h-10 brightness-0 invert opacity-80" />
          </div>
        </div>

        {/* Inline Form */}
        <div className="relative">
          <div className="absolute inset-0 bg-white/10 blur-3xl rounded-3xl" />
          <div className="relative bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-8 shadow-2xl" data-testid="inline-appointment-form">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-white/20 rounded-xl mb-3">
                <Calendar className="w-7 h-7 text-white" />
              </div>
              <h2 className="text-xl font-bold text-white">ENQUIRE NOW</h2>
              <p className="text-white/60 mt-1 text-sm">Fill in your details and we'll get back to you</p>
            </div>
            
            <form className="space-y-4">
              <select className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white text-sm" value={formData.location} onChange={(e) => setFormData({...formData, location: e.target.value})}>
                <option value="Sydney" className="text-slate-800">Sydney</option>
                <option value="Bundaberg" className="text-slate-800">Bundaberg</option>
              </select>
              <input type="text" placeholder="Your Name *" data-testid="inline-form-name" className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/50 text-sm" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} />
              <input type="email" placeholder="Your Email *" data-testid="inline-form-email" className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/50 text-sm" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} />
              <input type="tel" placeholder="Your Phone *" data-testid="inline-form-phone" className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/50 text-sm" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} />
              <select className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white text-sm" value={formData.service} onChange={(e) => setFormData({...formData, service: e.target.value})}>
                <option value="TMS/Esketamine" className="text-slate-800">TMS/Esketamine</option>
                <option value="ADHD" className="text-slate-800">ADHD</option>
                <option value="Depression" className="text-slate-800">Depression</option>
                <option value="Psychiatrist" className="text-slate-800">Psychiatrist</option>
                <option value="Psychology" className="text-slate-800">Psychology</option>
                <option value="Other" className="text-slate-800">Other</option>
              </select>
              <textarea placeholder="Any additional information?" data-testid="inline-form-message" rows={3} className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/50 text-sm resize-none" value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} />
              <button type="submit" data-testid="inline-form-submit" className="w-full bg-white text-[#6BACA9] hover:bg-slate-100 py-3 rounded-lg font-semibold transition-all">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

// ============ WELCOME SECTION ============
const WelcomeSection = () => (
  <section className="py-20 bg-white" data-testid="welcome-section">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <img src={IMAGES.logoSvg} alt="AwareHub" className="h-16 mx-auto mb-8" />
      <h2 className="text-2xl font-bold text-[#6BACA9] mb-8 tracking-wide">A dedicated and holistic mental health practice and a space for you to slow down, be mindful and enhance your mental wellbeing.</h2>
      <h3 className="text-xl font-bold text-slate-800 mb-6">Welcome To AwareHub</h3>
      <div className="space-y-4 text-slate-600 leading-relaxed text-sm">
        <p>Welcome to AwareHub! A bespoke mental health practice pioneered by psychiatrist, Dr Lisa Myers. Our passionate and caring team of psychiatrists, psychologists, neuropsychologist, dietician and occupational therapist, offer diverse child, adolescent, adult and family mental health services.</p>
        <p>At AwareHub, we realise the fundamentals of good mental health, which include flexibility and developing a strong sense of self. With this understanding, our focus is on offering a wide range of services provided by dedicated and client-centred professionals.</p>
        <p>We consider ourselves a family, and our clients are an extension of that family. We believe in upskilling each individual while also working together as a team to create a safe and inclusive community for our clients to work on their mental health.</p>
        <p>We hold a deep respect for our clients and the responsibility we have in treating them. We recognise that each person has unique needs, and we strive to tailor our approach to meet those needs. Our services include talk therapies, trauma-focused evidence-based therapies, medication management, and innovative treatments such as TMS and ketamine.</p>
        <p>Our goal is to provide accurate assessments, and we offer additional services such as brain mapping (qEEG), neuropsychology, and occupational therapy to guide these assessments and ensure holistic support is provided.</p>
        <p className="font-semibold text-[#6BACA9]">We are LGBTIQ+ friendly and are a Transgender Safe Space.</p>
      </div>
    </div>
  </section>
);

// ============ ABOUT DR LISA ============
const AboutDrLisaSection = () => (
  <section className="py-20 bg-[#6BACA9]" data-testid="about-section">
    <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
      <div className="flex justify-center">
        <img src={IMAGES.drLisa} alt="Dr Lisa Myers" className="rounded-2xl shadow-2xl w-full max-w-md object-cover" />
      </div>
      <div className="text-white space-y-6">
        <h2 className="text-2xl font-bold tracking-wide">About Dr Lisa Myers</h2>
        <p className="leading-relaxed text-white/90 text-sm">Dr Lisa Myers (BMed.Sc cum laude, MBCHB cum laude, FCPsych(SA), FRANZCP, Certificate Child Adolescent Psychiatry) is a qualified child and adolescent psychiatrist with over 18 years of experience in mental health.</p>
        <p className="leading-relaxed text-white/90 text-sm">She is a dynamic female psychiatrist and a mother of two teenage daughters. Lisa has an immense passion for mental health advocacy and has presented talks at schools, NGO's and conferences. She is a published author (<em>When the Light Goes Out</em>) and has created an online parenting program.</p>
        <blockquote className="border-l-4 border-white/40 pl-6 italic text-white/90">
          "It's never been more important to prioritise your mental health. AwareHub welcomes you to escape the stress of life, feel the support of our professionals, the peace and serenity of our space and re-energise, reflect and relax."
          <footer className="mt-2 not-italic font-semibold">— Dr Lisa Myers</footer>
        </blockquote>
      </div>
    </div>
  </section>
);

// ============ SERVICES SECTION ============
const ServicesSection = () => {
  const services = [
    { icon: Brain, title: "Adult Psychiatry" }, { icon: Heart, title: "Perinatal Psychiatry" },
    { icon: Users, title: "Psychology" }, { icon: Shield, title: "Occupational Therapy" },
    { icon: Users2, title: "Child Adolescent Psychiatry" }, { icon: Brain, title: "Neuropsychology Assessments" },
    { icon: Heart, title: "Dietetics & Nutrition" }, { icon: Heart, title: "NDIS" },
    { icon: Sparkles, title: "Next Step Treatments" }, { icon: Brain, title: "TMS", link: "/tms" },
    { icon: Shield, title: "EMDR" }, { icon: Brain, title: "QEEG" }
  ];
  return (
    <section className="py-20 bg-slate-50" data-testid="services-section">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-[#6BACA9] text-center mb-12 tracking-wide">OUR SERVICES</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {services.map((service, i) => {
            const content = (
              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all hover:-translate-y-1 cursor-pointer group">
                <div className="w-12 h-12 bg-[#6BACA9]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#6BACA9] transition-colors">
                  <service.icon className="w-6 h-6 text-[#6BACA9] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-semibold text-slate-800 text-sm group-hover:text-[#6BACA9] transition-colors">{service.title}</h3>
              </div>
            );
            return service.link ? <Link key={i} to={service.link}>{content}</Link> : <div key={i}>{content}</div>;
          })}
        </div>
      </div>
    </section>
  );
};

// ============ QUOTE SECTION ============
const QuoteSection = () => (
  <section className="py-16 bg-[#5D9E9B]">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <h2 className="text-2xl lg:text-3xl font-bold text-white italic leading-relaxed">"Your life only gets better when you do. Work on yourself and the rest will follow"</h2>
      <p className="text-white/80 mt-4 font-semibold text-lg">Dr Lisa Myers</p>
    </div>
  </section>
);

// ============ WELLNESS SECTION ============
const WellnessSection = () => {
  const wellness = [
    { icon: Brain, title: "Meditation" }, { icon: Shield, title: "Yoga" },
    { icon: Heart, title: "Dietetics & Nutrition" }, { icon: Palette, title: "Art Therapy" },
    { icon: Dumbbell, title: "Exercise Physiology" }, { icon: Users2, title: "Groups & Workshops" },
    { icon: Building2, title: "Corporate Wellness" }
  ];
  return (
    <section className="py-20 bg-white" data-testid="wellness-section">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-[#6BACA9] text-center mb-12 tracking-wide">Our Wellness Services</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {wellness.map((item, i) => (
            <div key={i} className="bg-slate-50 rounded-xl p-6 hover:bg-[#6BACA9]/5 transition-all cursor-pointer group text-center">
              <div className="w-12 h-12 bg-[#6BACA9]/10 rounded-lg flex items-center justify-center mb-4 mx-auto group-hover:bg-[#6BACA9] transition-colors">
                <item.icon className="w-6 h-6 text-[#6BACA9] group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-semibold text-slate-800 text-sm">{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ============ FAQ SECTION ============
const FAQSection = ({ onBookClick }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = [
    { q: "What conditions does AwareHub treat?", a: "AwareHub provides assessment and treatment for a wide range of mental health and neurodevelopmental conditions, including depression, anxiety disorders, ADHD, trauma-related conditions, OCD, and complex presentations where previous treatments have not been effective." },
    { q: "Do I need a referral to book an appointment?", a: "A referral is usually required to see a psychiatrist and access Medicare rebates. Referrals can be provided by your GP or another medical specialist. Psychology appointments may not require a referral, although a Mental Health Care Plan allows access to Medicare rebates." },
    { q: "Are your services covered by Medicare or private health insurance?", a: "Some services are eligible for Medicare rebates, particularly psychiatrist consultations and psychology sessions when you have an appropriate referral. Certain treatments, such as TMS therapy, may be covered by Medicare if eligibility criteria are met." },
    { q: "How do I know which treatment is right for me?", a: "The most appropriate treatment depends on your symptoms, diagnosis, treatment history and individual circumstances. During your assessment, your clinician will discuss options and develop a personalised treatment plan with you." },
    { q: "Do you offer telehealth appointments?", a: "Yes, telehealth appointments are available for many services where clinically appropriate. Some treatments, such as TMS or esketamine therapy, must be provided in person." },
  ];
  return (
    <section className="py-20 bg-slate-50" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-[#6BACA9] text-center mb-12 tracking-wide">FAQ</h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl shadow-md overflow-hidden">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-slate-50 transition-colors">
                <span className="font-semibold text-slate-800 text-sm">{faq.q}</span>
                {openIndex === i ? <Minus className="w-5 h-5 text-[#6BACA9]" /> : <Plus className="w-5 h-5 text-[#6BACA9]" />}
              </button>
              {openIndex === i && <div className="px-6 pb-4 text-slate-600 text-sm">{faq.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ============ NEWS SECTION ============
const NewsSection = () => {
  const news = [
    { title: "AwareHub launches revolutionary TMS Treatments in Bundaberg", img: IMAGES.drLisaDirector },
    { title: "AwareHub mental health clinic expands to region", img: IMAGES.tmsNurse },
    { title: "New therapies to help people with treatment-resistant depression", img: IMAGES.danielleFranco }
  ];
  return (
    <section className="py-20 bg-white" data-testid="news-section">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-[#6BACA9] text-center mb-12 tracking-wide">DISCOVER MORE</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {news.map((item, i) => (
            <div key={i} className="bg-slate-50 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all group cursor-pointer">
              <div className="h-48 overflow-hidden"><img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" /></div>
              <div className="p-6">
                <span className="text-[#6BACA9] text-xs font-semibold">Media & News</span>
                <h3 className="font-bold text-slate-800 mt-2 text-sm group-hover:text-[#6BACA9] transition-colors">{item.title}</h3>
                <a href="#" className="inline-flex items-center gap-1 text-[#6BACA9] font-semibold mt-4 hover:gap-2 transition-all text-sm">Read More <ChevronRight className="w-4 h-4" /></a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ============ FOOTER ============
const Footer = () => (
  <footer className="bg-[#1e293b] text-white py-16" data-testid="footer">
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid md:grid-cols-4 gap-12">
        <div>
          <img src={IMAGES.logoWhite} alt="AwareHub" className="h-12 mb-6" />
          <div className="space-y-3 text-slate-400 text-sm">
            <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-1 text-[#7DBDBA]" /><span>Suite 703/ 1 Newland Street, Bondi Junction, NSW 2022</span></div>
            <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-1 text-[#7DBDBA]" /><span>70-72 Crofton Street, Bundaberg QLD, 4670</span></div>
            <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#7DBDBA]" /><a href="tel:1300029273" className="hover:text-[#7DBDBA]">1300 029 273</a></div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#7DBDBA]" /><a href="mailto:reception@awarehub.com.au" className="hover:text-[#7DBDBA]">reception@awarehub.com.au</a></div>
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#7DBDBA]" /><a href="mailto:tms@awarehub.com.au" className="hover:text-[#7DBDBA]">tms@awarehub.com.au</a></div>
          </div>
        </div>
        <div><h4 className="font-bold mb-4">Quick Links</h4><ul className="space-y-2 text-slate-400 text-sm">
          <li><Link to="/" className="hover:text-[#7DBDBA] transition-colors">Home</Link></li>
          <li><a href="#" className="hover:text-[#7DBDBA] transition-colors">About</a></li>
          <li><a href="#" className="hover:text-[#7DBDBA] transition-colors">Services</a></li>
          <li><Link to="/tms" className="hover:text-[#7DBDBA] transition-colors">TMS</Link></li>
          <li><Link to="/esketamine" className="hover:text-[#7DBDBA] transition-colors">Esketamine</Link></li>
          <li><a href="#" className="hover:text-[#7DBDBA] transition-colors">Contact</a></li>
        </ul></div>
        <div><h4 className="font-bold mb-4">Our Services</h4><ul className="space-y-2 text-slate-400 text-sm">{["Psychiatry", "Psychology", "NDIS", "TMS Treatment", "Wellness"].map((link) => <li key={link}><a href="#" className="hover:text-[#7DBDBA] transition-colors">{link}</a></li>)}</ul></div>
        <div><h4 className="font-bold mb-4">Connect With Us</h4><div className="flex gap-3">
          <a href="https://www.facebook.com/awarehubclinic" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-[#6BACA9] transition-colors"><Facebook className="w-5 h-5" /></a>
          <a href="https://www.instagram.com/awarehub_clinic/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-[#6BACA9] transition-colors"><Instagram className="w-5 h-5" /></a>
          <a href="https://www.linkedin.com/in/lisa-myers-psychiatrist/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center hover:bg-[#6BACA9] transition-colors"><Linkedin className="w-5 h-5" /></a>
        </div></div>
      </div>
      <div className="border-t border-slate-700 mt-12 pt-8 text-center text-slate-500 text-sm">
        <p>AwareHub acknowledges and pays respect to the past, present and future Traditional Custodians and Elders of this nation and the continuation of cultural, spiritual and educational practices of Aboriginal and Torres Strait Islander peoples.</p>
      </div>
    </div>
  </footer>
);

// ============ HOMEPAGE COMPONENT ============
const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <Navigation onBookClick={() => setIsModalOpen(true)} />
      <CoverSection />
      <WelcomeSection />
      <AboutDrLisaSection />
      <ServicesSection />
      <QuoteSection />
      <WellnessSection />
      <FAQSection onBookClick={() => setIsModalOpen(true)} />
      <NewsSection />
      <Footer />
      <AppointmentModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

// ============ MAIN APP WITH ROUTER ============
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tms" element={<TMSPage />} />
          <Route path="/accelerated-tms" element={<AcceleratedTMSPage />} />
          <Route path="/esketamine" element={<EsketaminePage />} />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
